
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Select from 'react-select'



export const ConstructionTypeCommanDDL = () => {


    const {t}=useTranslation()

    const [ZoneNameID, setZoneNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const optionsZoneName = [
        { id: 1, value: 'अ क्षत्रिय कार्यालय ', label: 'अ क्षत्रिय कार्यालय ' },
        { id: 2, value: 'ब क्षत्रिय कार्यालय', label: 'ब क्षत्रिय कार्यालय' },
        { id: 3, value: 'क क्षत्रिय कार्यालय', label: 'क क्षत्रिय कार्यालय' },
        { id: 4, value: 'ड क्षत्रिय कार्यालय', label: 'ड क्षत्रिय कार्यालय' },
    ]

    return (
        <>

            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.ConstructionType')}</label><br />
            <Select
                id='ZoneNameID'
                isClearable={false}
                // isRtl={isRtl}
                isSearchable
                maxMenuHeight={130}
                value={{ value: ZoneNameID.ID, label: ZoneNameID.Label }}
                onChange={(e) => {
                    e ?
                        setZoneNameID({ ...ZoneNameID, ID: e.value, Label: e.label })
                        :
                        setZoneNameID({ ...ZoneNameID, ID: 0, Label: "Select..." })

                }}
                options={optionsZoneName}
            />
        </>
    )
}